class AutoSizer {
  constructor(selector = '[data-autosize]', options = {}) {
    this.selector = selector
    this.maxWidthCh = options.maxWidthCh || 30
    this.paddingCh = options.paddingCh || 0
    this.inputs = Array.from(document.querySelectorAll(this.selector))
    this._init()
  }

  _updateWidth(input, span, paddingPx, maxWidthPx) {
    const text = input.value || input.placeholder || ''
    span.textContent = text

    const contentWidth = span.offsetWidth + paddingPx
    const finalWidth = Math.min(contentWidth, maxWidthPx)
    input.style.width = `${finalWidth}px`
    console.log('setting width', finalWidth)
  }

  _init() {
    window.addEventListener('APPLICATION:RESIZE', () => {
      this.inputs.forEach((input) => {
        if (input._autoSizerSpan) {
          const computed = getComputedStyle(input)
          const chWidth = this._measureChWidth(computed)
          const maxWidthPx = this.maxWidthCh * chWidth
          const paddingPx = this.paddingCh * chWidth

          // Update the measuring span's styles to match current input styles
          const span = input._autoSizerSpan
          ;[
            'font',
            'fontSize',
            'fontFamily',
            'fontWeight',
            'letterSpacing',
            'textTransform',
            'lineHeight',
          ].forEach((key) => {
            span.style[key] = computed[key]
          })

          console.log('updating', {
            computed: computed,
            chWidth: chWidth,
            maxWidthPx: maxWidthPx,
            paddingPx: paddingPx,
          })

          this._updateWidth(input, span, paddingPx, maxWidthPx)
        }
      })
    })

    this.inputs.forEach((input) => {
      const computed = getComputedStyle(input)
      const chWidth = this._measureChWidth(computed)
      const maxWidthPx = this.maxWidthCh * chWidth
      const paddingPx = this.paddingCh * chWidth

      const span = document.createElement('span')
      span.style.position = 'fixed'
      span.style.visibility = 'hidden'
      span.style.whiteSpace = 'pre'
      span.style.boxSizing = 'content-box'

      // Copy all relevant visual styles
      ;[
        'font',
        'fontSize',
        'fontFamily',
        'fontWeight',
        'letterSpacing',
        'textTransform',
        'lineHeight',
      ].forEach((key) => {
        span.style[key] = computed[key]
      })

      document.body.appendChild(span)

      // Create a function that recalculates dimensions
      const recalculateAndUpdate = () => {
        const newComputed = getComputedStyle(input)
        const newChWidth = this._measureChWidth(newComputed)
        const newMaxWidthPx = this.maxWidthCh * newChWidth
        const newPaddingPx = this.paddingCh * newChWidth

        // Update the span styles
        ;[
          'font',
          'fontSize',
          'fontFamily',
          'fontWeight',
          'letterSpacing',
          'textTransform',
          'lineHeight',
        ].forEach((key) => {
          span.style[key] = newComputed[key]
        })

        this._updateWidth(input, span, newPaddingPx, newMaxWidthPx)
      }

      // Initial update
      this._updateWidth(input, span, paddingPx, maxWidthPx)

      // Listen for input changes
      input.addEventListener('input', recalculateAndUpdate)

      const observer = new MutationObserver(recalculateAndUpdate)
      observer.observe(input, {
        attributes: true,
        attributeFilter: ['placeholder', 'style', 'class'],
      })

      input._autoSizerSpan = span
    })
  }

  _measureChWidth(computedStyle) {
    const span = document.createElement('span')
    span.textContent = '0'
    span.style.position = 'absolute'
    span.style.visibility = 'hidden'
    span.style.whiteSpace = 'pre'
    span.style.font = computedStyle.font
    span.style.fontSize = computedStyle.fontSize
    span.style.fontFamily = computedStyle.fontFamily
    span.style.fontWeight = computedStyle.fontWeight
    span.style.letterSpacing = computedStyle.letterSpacing

    document.body.appendChild(span)
    const width = span.offsetWidth
    span.remove()
    return width
  }

  destroy() {
    this.inputs.forEach((input) => {
      if (input._autoSizerSpan) {
        input._autoSizerSpan.remove()
        delete input._autoSizerSpan
      }
    })
  }
}

export default AutoSizer
